<template>
  <v-card outlined :loading="loading">
    <v-card-title class="d-flex justify-space-between pb-0">
      <h6 class="mb-0 lh-1">Campanhas</h6>
    </v-card-title>
    <div class="pt-0 px-0 pb-0">
      <div class="d-flex flex-column mx-4 my-3">
        <div
          v-for="item in sortedData"
          :key="item.name"
          class="d-flex align-center gap-2"
        >
          <span style="flex: 2">{{ item.name }}</span>
          <v-progress-linear
            :value="(item.amount / totalAmount) * 100"
            color="primary"
            height="5"
            rounded
            style="flex: 5"
          ></v-progress-linear>
          <span style="flex: 2">{{ item.amount | currency }}</span>
        </div>
      </div>

      <v-divider class="mt-4 "></v-divider>
      <v-simple-table :items="sortedData" dense>
        <thead>
          <tr>
            <th v-for="header in headers" :key="header.value">
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in sortedData" :key="item.name">
            <td>{{ item.name }}</td>
            <td>{{ item.amount | currency }}</td>
            <td>{{ item.tickets | number }}</td>
            <td>{{ item.payments.length | number }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </v-card>
</template>


<script>
export default {
  props: {
    reducedData: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: "Campanha", value: "name" },
        { text: "Valor", value: "amount" },
        { text: "Ingressos", value: "tickets" },
        { text: "Pagamentos", value: "payments.length" },
      ],
    };
  },
  computed: {
    sortedData() {
      return Object.values(this.reducedData.campaign).sort(
        (a, b) => b.amount - a.amount
      );
    },
    totalAmount() {
      return this.sortedData.reduce((acc, item) => acc + item.amount, 0);
    },
  },
};
</script>

